import { render, staticRenderFns } from "./zcollapsemenu.vue?vue&type=template&id=29543842&"
import script from "./zcollapsemenu.vue?vue&type=script&lang=js&"
export * from "./zcollapsemenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports